import React from 'react';
import PropTypes from 'prop-types';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import NavCalendarPagination from '../NavCalendarPagination/NavCalendarPagination';
import NavCalendarScrolling from '../NavCalendarScrolling/NavCalendarScrolling';

function NavCalendar(props) {
    const {isInline, isMobile, mobileBehavior, ...rest} = props;

    if ((isMobile && mobileBehavior === 'scrolling') || isInline) {
        return (
            <NavCalendarScrolling
                isInline={isInline}
                isMobile={isMobile}
                {...rest}
            />
        );
    }

    return (
        <NavCalendarPagination
            isMobile={isMobile}
            mobileBehavior={
                mobileBehavior !== 'scrolling' ? mobileBehavior : null
            }
            {...rest}
        />
    );
}

NavCalendar.defaultProps = {
    ...NavCalendarPagination.defaultProps,
    isInline: false,
};

NavCalendar.propTypes = {
    ...NavCalendarScrolling.propTypes,
    ...NavCalendarPagination.propTypes,
    /** There are four different mobile behaviors (Two are only for use in DateRangePicker with the affiliates program). 1) scrolling - switches to a vertical scrolling list. 2) single - collapses to a single month. 3) single-affiliates - special single month mode for affiliates program (fits within 392px height). 4) double-affiliates - special double month mode for affiliates program (fits within 392px height). */
    mobileBehavior: PropTypes.oneOf([
        'scrolling',
        'single',
        'single-affiliates',
        'double-affiliates',
    ]),
    /** Number of months to show in a desktop horizontal list, or initial number of months to show in scrolling calendar to ensure that a scroll overflow is created to enable infinite scroll. */
    numMonthsToDisplay: PropTypes.number,
};

export default determineIfMobile(NavCalendar);
